"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@openfonts/dm-sans_latin/index.css");
require("@openfonts/source-sans-pro_latin/index.css");
require("@openfonts/ubuntu-mono_latin/index.css");
